import { SuggestionListItemServices, SuggestionsList } from './suggestions-list';
import { getServiceElementIndex } from './utils/get-element-index';
import React from 'react';
import { ServiceSuggestion, SlicedSuggestions } from 'types/suggestions';
import { useSuggestionsButtonAction } from '../hooks/use-suggestions-button-action';
import { useTranslation } from 'react-i18next';

type ServicesListProps = {
  showServices: boolean;
  suggestionSelector: string;
  isDefaultList: boolean;
  index: number;
  isSrp: boolean;
  suggestions: SlicedSuggestions;
  withDivider: boolean;
  slicedServices: ServiceSuggestion[];
  buttonAction: ReturnType<typeof useSuggestionsButtonAction>;
  showOnlyCategories: boolean;
};

export const ServicesList: React.FC<ServicesListProps> = ({
  showServices,
  suggestions,
  index,
  isSrp,
  isDefaultList,
  withDivider,
  slicedServices,
  suggestionSelector,
  buttonAction,
  showOnlyCategories,
}) => {
  const { t } = useTranslation();

  if (showOnlyCategories && !showServices) return null;

  return (
    <SuggestionsList
      suggestionSelector={suggestionSelector}
      withTitle={false}
      withDivider={withDivider}
      title={t('header.searchbar.services')}
      aria-label={t('header.searchbar.services-aria')}
      data-qa={'service-suggestions'}
    >
      {slicedServices.map((item, idx) => (
        <SuggestionListItemServices
          servicesSuggestion={item}
          elementIndex={getServiceElementIndex(idx, suggestions, isDefaultList)}
          navigationIndex={index}
          buttonAction={buttonAction}
          isSrp={isSrp}
          suggestionSelector={suggestionSelector}
          key={item.serviceId}
        />
      ))}
    </SuggestionsList>
  );
};
